import { render, staticRenderFns } from "./UserDelegates.vue?vue&type=template&id=18081bf1&"
import script from "./UserDelegates.vue?vue&type=script&lang=js&"
export * from "./UserDelegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports